/*
 * Copyright 2018 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// automatically generated by the FlatBuffers compiler, do not modify

/**
 * @const
 * @namespace
 */
var Catapult = Catapult || {};

/**
 * @const
 * @namespace
 */
Catapult.Buffers = Catapult.Buffers || {};

/**
 * @constructor
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer = function () {
	/**
	 * @type {flatbuffers.ByteBuffer}
	 */
	this.bb = null;

	/**
	 * @type {number}
	 */
	this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Catapult.Buffers.NamespaceCreationTransactionBuffer}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.__init = function (i, bb) {
	this.bb_pos = i;
	this.bb = bb;
	return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Catapult.Buffers.NamespaceCreationTransactionBuffer=} obj
 * @returns {Catapult.Buffers.NamespaceCreationTransactionBuffer}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.getRootAsNamespaceCreationTransactionBuffer = function (bb, obj) {
	return (obj || new Catapult.Buffers.NamespaceCreationTransactionBuffer).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.size = function () {
	var offset = this.bb.__offset(this.bb_pos, 4);
	return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
};

/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.signature = function (index) {
	var offset = this.bb.__offset(this.bb_pos, 6);
	return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.signatureLength = function () {
	var offset = this.bb.__offset(this.bb_pos, 6);
	return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns {Uint8Array}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.signatureArray = function () {
	var offset = this.bb.__offset(this.bb_pos, 6);
	return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.signer = function (index) {
	var offset = this.bb.__offset(this.bb_pos, 8);
	return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.signerLength = function () {
	var offset = this.bb.__offset(this.bb_pos, 8);
	return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns {Uint8Array}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.signerArray = function () {
	var offset = this.bb.__offset(this.bb_pos, 8);
	return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.version = function () {
	var offset = this.bb.__offset(this.bb_pos, 10);
	return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.type = function () {
	var offset = this.bb.__offset(this.bb_pos, 12);
	return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
};

/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.fee = function (index) {
	var offset = this.bb.__offset(this.bb_pos, 14);
	return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.feeLength = function () {
	var offset = this.bb.__offset(this.bb_pos, 14);
	return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.feeArray = function () {
	var offset = this.bb.__offset(this.bb_pos, 14);
	return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.deadline = function (index) {
	var offset = this.bb.__offset(this.bb_pos, 16);
	return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.deadlineLength = function () {
	var offset = this.bb.__offset(this.bb_pos, 16);
	return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.deadlineArray = function () {
	var offset = this.bb.__offset(this.bb_pos, 16);
	return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.namespaceType = function () {
	var offset = this.bb.__offset(this.bb_pos, 18);
	return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
};

/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.durationParentId = function (index) {
	var offset = this.bb.__offset(this.bb_pos, 20);
	return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.durationParentIdLength = function () {
	var offset = this.bb.__offset(this.bb_pos, 20);
	return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.durationParentIdArray = function () {
	var offset = this.bb.__offset(this.bb_pos, 20);
	return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @param {number} index
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.namespaceId = function (index) {
	var offset = this.bb.__offset(this.bb_pos, 22);
	return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.namespaceIdLength = function () {
	var offset = this.bb.__offset(this.bb_pos, 22);
	return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns {Uint32Array}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.namespaceIdArray = function () {
	var offset = this.bb.__offset(this.bb_pos, 22);
	return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @returns {number}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.namespaceNameSize = function () {
	var offset = this.bb.__offset(this.bb_pos, 24);
	return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.prototype.namespaceName = function (optionalEncoding) {
	var offset = this.bb.__offset(this.bb_pos, 26);
	return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param {flatbuffers.Builder} builder
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.startNamespaceCreationTransactionBuffer = function (builder) {
	builder.startObject(12);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} size
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addSize = function (builder, size) {
	builder.addFieldInt32(0, size, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} signatureOffset
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addSignature = function (builder, signatureOffset) {
	builder.addFieldOffset(1, signatureOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.createSignatureVector = function (builder, data) {
	builder.startVector(1, data.length, 1);
	for (var i = data.length - 1; i >= 0; i--) {
		builder.addInt8(data[i]);
	}
	return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.startSignatureVector = function (builder, numElems) {
	builder.startVector(1, numElems, 1);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} signerOffset
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addSigner = function (builder, signerOffset) {
	builder.addFieldOffset(2, signerOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.createSignerVector = function (builder, data) {
	builder.startVector(1, data.length, 1);
	for (var i = data.length - 1; i >= 0; i--) {
		builder.addInt8(data[i]);
	}
	return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.startSignerVector = function (builder, numElems) {
	builder.startVector(1, numElems, 1);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} version
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addVersion = function (builder, version) {
	builder.addFieldInt16(3, version, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} type
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addType = function (builder, type) {
	builder.addFieldInt16(4, type, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} feeOffset
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addFee = function (builder, feeOffset) {
	builder.addFieldOffset(5, feeOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.createFeeVector = function (builder, data) {
	builder.startVector(4, data.length, 4);
	for (var i = data.length - 1; i >= 0; i--) {
		builder.addInt32(data[i]);
	}
	return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.startFeeVector = function (builder, numElems) {
	builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} deadlineOffset
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addDeadline = function (builder, deadlineOffset) {
	builder.addFieldOffset(6, deadlineOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.createDeadlineVector = function (builder, data) {
	builder.startVector(4, data.length, 4);
	for (var i = data.length - 1; i >= 0; i--) {
		builder.addInt32(data[i]);
	}
	return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.startDeadlineVector = function (builder, numElems) {
	builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} namespaceType
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addNamespaceType = function (builder, namespaceType) {
	builder.addFieldInt8(7, namespaceType, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} durationParentIdOffset
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addDurationParentId = function (builder, durationParentIdOffset) {
	builder.addFieldOffset(8, durationParentIdOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.createDurationParentIdVector = function (builder, data) {
	builder.startVector(4, data.length, 4);
	for (var i = data.length - 1; i >= 0; i--) {
		builder.addInt32(data[i]);
	}
	return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.startDurationParentIdVector = function (builder, numElems) {
	builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} namespaceIdOffset
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addNamespaceId = function (builder, namespaceIdOffset) {
	builder.addFieldOffset(9, namespaceIdOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.createNamespaceIdVector = function (builder, data) {
	builder.startVector(4, data.length, 4);
	for (var i = data.length - 1; i >= 0; i--) {
		builder.addInt32(data[i]);
	}
	return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.startNamespaceIdVector = function (builder, numElems) {
	builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} namespaceNameSize
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addNamespaceNameSize = function (builder, namespaceNameSize) {
	builder.addFieldInt8(10, namespaceNameSize, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} namespaceNameOffset
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.addNamespaceName = function (builder, namespaceNameOffset) {
	builder.addFieldOffset(11, namespaceNameOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.endNamespaceCreationTransactionBuffer = function (builder) {
	var offset = builder.endObject();
	return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} offset
 */
Catapult.Buffers.NamespaceCreationTransactionBuffer.finishNamespaceCreationTransactionBufferBuffer = function (builder, offset) {
	builder.finish(offset);
};

// Exports for Node.js and RequireJS
export default Catapult;